import { BAPI_COMMANDS } from "@/bapi-client/types/commands";
import type { BAPIParams } from "@/bapi-client/types/bapiParams";
import { fetchHandler } from "@/bapi-client/fetch";
import { type Result } from "../types";
import { type Location } from "../types/common/location";
import type { ParamsGetAllLocations, ParamsGetLocations } from "../types/common/location";

export async function getOrigins(opts: ParamsGetLocations): Promise<Result<Location[]>> {
  const path = `/reports/${opts.customerId}/origins`;

  const body: BAPIParams[typeof BAPI_COMMANDS.GET_ORIGINS] = {
    group_ids: opts.reportingGroupIds,
  };
  if (opts.searchTerm) {
    body.search_term = opts.searchTerm;
  }
  const response = await fetchHandler(BAPI_COMMANDS.GET_ORIGINS, "POST", path, { body });

  if (!response.success) {
    return response;
  }

  const { data } = response;
  const jsonResult = await data.json();

  return !jsonResult.success ? jsonResult : { success: true, data: jsonResult.data.data };
}

export async function getDestinations(opts: ParamsGetLocations): Promise<Result<Location[]>> {
  const path = `/reports/${opts.customerId}/destinations`;

  const body: BAPIParams[typeof BAPI_COMMANDS.GET_DESTINATIONS] = {
    group_ids: opts.reportingGroupIds,
  };
  if (opts.searchTerm) {
    body.search_term = opts.searchTerm;
  }
  const response = await fetchHandler(BAPI_COMMANDS.GET_DESTINATIONS, "POST", path, { body });

  if (!response.success) {
    return response;
  }

  const { data } = response;
  const jsonResult = await data.json();

  return !jsonResult.success ? jsonResult : { success: true, data: jsonResult.data.data };
}

export async function getAllLocations(opts: ParamsGetAllLocations): Promise<Result<Location[]>> {
  const path = `/locations`;

  const body: BAPIParams[typeof BAPI_COMMANDS.GET_ALL_LOCATIONS] = {
    search: opts.search,
    only_junctions: opts.only_junctions,
    scac: opts.scac,
  };
  const response = await fetchHandler(BAPI_COMMANDS.GET_ALL_LOCATIONS, "POST", path, { body });

  if (!response.success) {
    return response;
  }

  const { data } = response;
  const jsonResult = await data.json();

  return !jsonResult.success ? jsonResult : { success: true, data: jsonResult.data.data };
}
